import client from 'lib/apiClient';

const BASEURL = 'API/1_0/product.php';

export const getProducts = (params) => client.get(BASEURL, { params });

export const getProductDetails = (hash) =>
  client.get(BASEURL, { params: { hash, load_prices: 1 } }).then((r) => r[0]);

export const addProductToOrder = (price_hash, account_id) =>
  client.post(`API/1_0/productPriceToOrder.php`, { price_hash, account_id });

export const getPrices = (ids) =>
  Promise.all(
    ids.map((i) =>
      client
        .get(`API/1_0/productPrice.php`, {
          params: { stripe_price_id: i, load_product: 1 },
        })
        .then((r) => r[0]),
    ),
  ).then((r) => r.filter(Boolean));

export const placeOrder = (cartHash) =>
  client.post(`API/1_0/productOrder.php`, { hash: cartHash, status: 'buy' });

export const getProductLinks = (product_hash) =>
  client.get(`API/1_0/productLink.php`, { params: { product_hash } });

export const addProductLink = (product_id, link) =>
  client.post(`API/1_0/productLink.php`, { product_id, link });

export const updateProductLink = (hash, link) =>
  client.post(`API/1_0/productLink.php`, { hash, link });

export const deleteProductLink = (hash) =>
  client.delete(`API/1_0/productLink.php`, { params: { hash } });

export const getAdditionalMedia = (product_hash) =>
  client.get(`API/1_0/productAdditionalMedia.php`, {
    params: { product_hash },
  });

export const addAdditionalMedia = (payload) =>
  client.post(`API/1_0/productAdditionalMedia.php`, payload);

export const deleteAdditionalMedia = (hash) =>
  client.delete(`API/1_0/productAdditionalMedia.php`, { params: { hash } });

export const getProductGroups = (product_hash) =>
  client.get(`API/1_0/productToGroup.php`, {
    params: { product_hash, load_group: 1 },
  });

export const saveProductGroups = (product_id, group_id) =>
  client.post(`API/1_0/productToGroup.php`, { product_id, group_id });

export const deleteProductGroup = (hash) =>
  client.delete(`API/1_0/productToGroup.php`, { params: { hash } });

export const getCategories = (query = {}) =>
  client.get(`API/1_0/categories.php`, {
    params: { type: 'product', ...query },
  });

export const getCategoriesByProduct = (product_hash) =>
  client.get(`API/1_0/categoryItems.php`, {
    params: { product_hash },
  });

export const addProductCategory = (object_id, category_id) =>
  client.post(`API/1_0/categoryItems.php`, { object_id, category_id });

export const removeProductCategory = (hash) =>
  client.delete(`API/1_0/categoryItems.php`, { params: { hash } });
